import { courses } from "../data";

function Courses() {
  return (
    <section className="section" id="courses">
      <p className="sectionTag center">Our Batches</p>
      <h2 className="sectionHeading">Courses & Batches We Provide</h2>

      <div className="courseGrid">
        {courses.map((course, index) => (
          <div className="courseCard" key={index}>
            <div className="courseIcon">{course.icon}</div>
            <h3>{course.title}</h3>
            <h4>{course.details}</h4>
            <p>{course.sub}</p>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Courses;
